<template>
  <v-app :style="{background: this.$vuetify.theme.themes.light.background}">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center" no-gutters>
          <v-col class="mb-10" cols="12">
            <span class="display-2">
              <v-icon class="mr-2" style="font-size: 65px;vertical-align: text-bottom;" color="accent">mdi-cloud-outline</v-icon>
              原価管理システム
            </span>
          </v-col>
          <v-col cols="12">
            <v-btn color="primary" :to="{name: 'Login'}">
              <v-icon>mdi-login-variant</v-icon>ログイン
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    name: "Landing",
    data: () => ({
    }),
  };
</script>